// extracted by mini-css-extract-plugin
export default {"custo-fabricacao-box":"CustoFabricacaoBox_custo-fabricacao-box__ybzSz"};